const assetPath = (fileName: string) => `${import.meta.env.BASE_URL}featured-label-logos/${fileName}`;

export const INITIAL_FEATURED_BRAND_LOGOS: Record<string, string> = {
  ethnc: assetPath("1.webp"),
  khaadi: assetPath("2.webp"),
  sapphire: assetPath("3.webp"),
  studiosy: assetPath("4.webp"),
  qalamkar: assetPath("5.webp"),
  beechtree: assetPath("6.webp"),
  lulusar: assetPath("7.webp"),
  vanya: assetPath("vanya-black.jpg"),
  "junaid-jamshed": "https://www.junaidjamshed.com/cdn/shop/files/logo_black_-_wania_saleem.svg?v=1765460151&width=100",
  "silayi-pret": assetPath("silayi-pret.png"),
};

export const FEATURED_BRAND_LOGO_SCALE: Record<string, string> = {
  khaadi: "scale-[1.2]",
  studiosy: "scale-[1.25]",
  lulusar: "scale-[1.3]",
};